<template>
<div>
  <div class="stage-description" v-if="styleType === '1'">
    <el-link type="primary"  @click="handleClick"><i class="el-icon-view el-icon--right"></i> {{ viewFileName?viewFileName:filename }}</el-link>
    <el-link v-if="id&&filename!='未上传'" target="_blank" @click="handleDownload"><span v-html="'\u00a0\u00a0'"></span>下载 <i class="el-icon-download el-icon--right"></i> </el-link>
  </div>

  <div class="preview" v-else>
    <el-button class="button" type="text" @click="handleClick"><i class="el-icon-view el-icon--right"></i> {{ filename }}</el-button>
    <el-button v-if="id" class="red" type="text" @click="handleDownload">下载 <i class="el-icon-download el-icon--right"></i> </el-button>
  </div>
</div>
</template>

<script>
import { queryByFileId } from '../../api/upload'
import { download } from '@/shared/file'

export default {
  name: 'FilePreview',
  props: {
    id: String,
    viewFileName: String,
    className: String,
    styleType: String

  },
  data() {
    return {
      filename: '未上传'
    }
  },
  watch: {
    id: {
      handler(v) {
        if (v) {
          queryByFileId({ fileId: v }).then(res => {
            if(res.data){
            const { fileName } = res.data
            this.filename = fileName
            }
        
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClick() {
      if (this.id) {
        window.open(`/zcjf/base/file/download/${this.id}`)
      }
    },
    handleDownload() {
      download(this.id)
    }
  }
}
</script>

<style scoped>
.preview {
  display: inline-block;
  width: 100%;
  overflow: hidden;
}
.button {
  width: 100%;
}
.button /deep/ span {
  display: block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
}
.red {
  color: red;
}
</style>
<style lang="scss">
.stage-element-box {
  color: #333;
  fonr-size: 16px;
  font-weight: 600;
  width: 100%;
  display: flex;
  text-align: center;
  .stage-description {
    margin-top: 10px;
    font-size: 14px;
    font-weight: normal;
  }

}
</style>
